module.exports = __webpack_public_path__ + "img/art.98e54446.png";